__turbopack_context__.v({
  "awayDetails": "TournamentMatchResults-module__RI_a3G__awayDetails",
  "card": "TournamentMatchResults-module__RI_a3G__card",
  "details": "TournamentMatchResults-module__RI_a3G__details",
  "homeDetails": "TournamentMatchResults-module__RI_a3G__homeDetails",
  "row": "TournamentMatchResults-module__RI_a3G__row",
});
